import { render, staticRenderFns } from "./SearchCategory.vue?vue&type=template&id=ee2d39ca&scoped=true"
import script from "./SearchCategory.vue?vue&type=script&lang=ts"
export * from "./SearchCategory.vue?vue&type=script&lang=ts"
import style0 from "./SearchCategory.vue?vue&type=style&index=0&id=ee2d39ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2d39ca",
  null
  
)

export default component.exports